import { DisposalSet, select } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

const PARALLAX_FACTOR = 0.75;

registerFragment('chroa-full-page-hero', (el, config, meta) => {
    const bgInnerEl = select<HTMLDivElement>(el, '.chroa-full-page-hero__bg-inner');

    if (!CSS.supports('(animation-timeline: scroll(root))')) {
        bgInnerEl.classList.add('chroa-full-page-hero__bg-inner--fallback');
        console.log('falling back to scroll event animation');
        const doParallax = () => {
            bgInnerEl.style.transform = `translate3d(0,${window.scrollY}px,0)`;
        };

        (gc.register(window)
            .addListener('scroll', doParallax)
            .addListener('resize', doParallax)
        );
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
